<template>
  <div>
    <div class="container mx-auto h-auto laptop:h-almostscreen flex-col flex md:justify-center laptop:min-700 fullhd:min-900 min-h-0 relative">
      <h1 class="relative bottom-1/4">
        <div class="px-5 pt-5 laptop:-mt-12 laptop:absolute laptop:px-0 laptop:text-10xl lg:text-7xl md:text-52xl laptop:w-5/6 md:font-semibold z-0">
          {{ $t('viewer.hero-1') }}<span class="lg:hidden"> <br>{{ $t('viewer.hero-1-cont') }}</span>
        </div>
        <img loading="lazy" src="~/assets/img/viewer-hero.webp" class="hidden w-full xl:block laptop:absolute mx-auto ">
        <div class="hidden lg:block px-5 laptop:absolute laptop:px-0 laptop:pt-40 laptop:w-full laptop:text-ultra lg:text-7xl md:text-52xl md:w-3/4 md:font-semibold laptop:text-right z-20">
          {{ $t('viewer.hero-1-cont') }}
        </div>
        <img loading="lazy" src="~/assets/img/viewer-hero-mobile.webp" class="block xl:hidden">
      </h1>
      <div class="w-16 h-16 hidden laptop:block absolute bottom-0 mb-6 left-1/2 -ml-8 z-20">
        <img loading="lazy" class="mx-auto" src="~/assets/img/scroll-down-gif.gif" alt="Scroll down indicator">
      </div>
    </div>
    <div class="container mx-auto flex flex-col md:flex-row laptop:mt-150px pt-10 md:pt-16">
      <div class="laptop:w-5/12 p-5 md:p-0 laptop:pl-0 laptop:mx-24 md:mx-8 md:w-1/2">
        <MARSTitle><div v-html="$t('viewer.claim')" /></MARSTitle>
        <p class="text-standard laptop:text-slg md:text-base md:w-full laptop:w-10/12 fullhd:w-9/12" v-html="$t('viewer.claim-text')" />
        <ActionButton bg="orange" :href="panelLinks.registerUrl.value" margin-top="mt-5" :value="$t('home.free-trial')" />
      </div>
      <div class="laptop:w-5/12 laptop:mr-24 p-5 md:p-0 md:mx-8 laptop:p-0 md:w-3/6 lg:min-h-0">
        <iframe
          allow="xr-spatial-tracking *;"
          style="width:100%;" class="h-fiftyvh md:h-full"
          :src="'https://viewer.myarstudio.cloud/viewer_master/index.html?p=a1d4933a-8faa-5d2a-9edd-dd57950f42bd&c=7ef9a9ef-455f-5d71-a345-0edad45b6fce&b=f2f01834-6984-4e4d-bd20-8e7586523cf0&language=' + $i18n.locale"
        />
      </div>
    </div>
    <div class="container mx-auto md:mt-32 laptop:my-150px">
      <div class="mx-5 md:mx-8 laptop:mx-24">
        <MARSTitle><div v-html="$t('viewer.advantages')" /></MARSTitle>
        <div class="mt-12 laptop:mt-100px grid grid-cols-1 laptop:grid-cols-4 md:grid-cols-2 gap-x-8 mb-12">
          <div class="w-full px-0 laptop:pl-0 my-6 laptop:my-12">
            <img loading="lazy" class="" src="~/assets/img/ico-pc.svg">
            <p class="font-bold my-4 laptop:my-8" v-html="$t('viewer.adv-1')" />
            <p v-html="$t('viewer.adv-1-text')" />
          </div>
          <div class="w-full px-0 my-6 laptop:my-12">
            <img loading="lazy" src="~/assets/img/ico-cart.svg">
            <p class="font-bold my-4 laptop:my-8" v-html="$t('viewer.adv-2')" />
            <p v-html="$t('viewer.adv-2-text')" />
          </div>
          <div class="w-full px-0 my-6 laptop:my-12">
            <img loading="lazy" src="~/assets/img/ico-phone.svg">
            <p class="font-bold my-4 laptop:my-8" v-html="$t('viewer.adv-3')" />
            <p v-html="$t('viewer.adv-3-text')" />
          </div>
          <div class="w-full px-0 my-6 laptop:my-12">
            <img loading="lazy" src="~/assets/img/ico-people.svg">
            <p class="font-bold my-4 laptop:my-8" v-html="$t('viewer.adv-4')" />
            <p v-html="$t('viewer.adv-4-text')" />
          </div>
        </div>
      </div>
    </div>
    <div class="laptop:mx-24">
      <div class="container mx-auto mt-32 laptop:mt-0" style="max-width: 1280px;">
        <div style="position: relative; width: 100%; padding-top: 56.25%;">
          <div class="w-full h-full absolute top-0">
            <iframe v-if="youtubeEnabled && $i18n.locale != 'it'" width="100%" height="100%" src="https://www.youtube.com/embed/4NCU6yGZ9R4?rel=0" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen />
            <iframe v-if="!youtubeEnabled && $i18n.locale != 'it'" width="100%" height="100%" src="https://www.youtube-nocookie.com/embed/4NCU6yGZ9R4?rel=0" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen />
            <iframe v-if="youtubeEnabled && $i18n.locale == 'it'" width="100%" height="100%" src="https://www.youtube.com/embed/rGy0_ukkC_A?rel=0" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen />
            <iframe v-if="!youtubeEnabled && $i18n.locale == 'it'" width="100%" height="100%" src="https://www.youtube-nocookie.com/embed/rGy0_ukkC_A?rel=0" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen />
          </div>
        </div>
      </div>
    </div>
    <div
      class="w-full bg-right bg-cover laptop:my-150px my-12"
    >
      <div class="container h-full mx-auto">
        <div class="flex flex-col justify-around h-full laptop:ml-24 p-5 md:p-8 md:px-8 laptop:px-0">
          <div>
            <p class="text-standard laptop:text-slg font-bold" v-html="$t('viewer.see-example')" />
            <ActionButton route="examples" margin-top="mt-8" :value="$t('viewer.see-example-cta')" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useIubenda } from 'mars-iubenda-vite';
import { usePanelLinks } from '~/composables/PanelLinks';

const {youtubeEnabled} = useIubenda()
const panelLinks = usePanelLinks()
</script>

<style scoped>
.hero {
  background-image: url("~/assets/img/viewer-hero.webp");
}
</style>
